import Cookies from "universal-cookie";
export class Storage {
  #name;
  #options = {};
  #cookies = new Cookies();
  constructor(name = required(), value = {}, options = {}) {
    this.#name = name;
    this.#options = options;
    if (!this.value) {
      this.value = value;
    }
  }

  set value(value) {
    this.#cookies.set(this.#name, value, {
      path: "/",
      maxAge: 60 * 60 * 24, // one day
      secure: true,
      sameSite: "strict",
      ...this.#options,
    });
  }

  get value() {
    return this.#cookies.get(this.#name);
  }

  get allCookie() {
    return this.#cookies.getAll(this.#name);
  }

  sessionDestroy(next = (r) => r) {
    this.#cookies.remove(this.#name, {
      path: "/",
      maxAge: 60 * 60 * 24, // one day
      secure: true,
      sameSite: "strict",
      ...this.#options,
    });
    next();
  }
}

function required() {
  throw new Error("Storage: missing parameter");
}
